<app-overview>
  <div appOverviewHeader class="project-staff-data-overview__header">
    <h2 class="mat-body-large">{{"Personaldaten" | translate : "header-headline-staff-data"}}</h2>
    <button mat-stroked-button class="project-staff__reset-button" (appThrottleClick)="reset()">
      <ogs-m3-icon icon="rotate-right" matButtonIcon/>
      {{"Zurücksetzen" | translate : "action-reset"}}
    </button>
  </div>

  @let staffData = projectStaffData();
  @if(staffData){
    <app-table>
      <app-table-header-group>
        <app-table-header-row>
          <app-table-header class="mat-body-medium" [width]="439">
            {{"Bereich und Feldname" | translate : 'label-area-and-field-name'}}
          </app-table-header>
          <app-table-header class="mat-body-medium" [width]="99">
            {{"Sichtbarkeit" | translate : 'label-visibility'}}
          </app-table-header>
          <app-table-header class="mat-body-medium" [width]="99">
            {{"Pflichtfeld" | translate : 'label-required-field'}}
          </app-table-header>
          <app-table-header class="mat-body-medium" [width]="946">
            {{"Eigenschaften" | translate : 'label-properties'}}
          </app-table-header>
        </app-table-header-row>
      </app-table-header-group>

      <app-table-data-group>
        <mat-accordion appTableAccordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-body-medium">
                {{"Anpassbare Grunddaten" | translate : 'label-customizable-basic-data'}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Positionsbezeichnung' | translate : 'label-position-title'), options: staffData.position, descriptionDefaultText: ''}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Geschlecht' | translate : 'label-gender'), options: staffData.gender, descriptionDefaultText: ''}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Geburtsdatum' | translate : 'label-date-of-birth'), options: staffData.dateOfBirth, descriptionDefaultText: 'Empfohlen zur Verifikation des Baustellenausweises'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Geburtsort' | translate : 'label-place-of-birth'), options: staffData.birthPlace, descriptionDefaultText: ''}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Nationalität' | translate : 'label-nationality'), options: staffData.nationality, descriptionDefaultText: 'Die Auswahl der Nationalität definiert die Vorauswahl der Korrespondenzsprache'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Sprache' | translate : 'label-language'), options: staffData.correspondenceLanguage, descriptionDefaultText: 'Empfohlen zur Auswahl der Sprache für MLND - wird dieses Feld nicht verwendet, ist die Sprache für die MLND Englisch'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Mitarbeiter-Foto' | translate : 'label-employee-photo'), options: staffData.userImage, descriptionDefaultText: 'Empfohlen für den Baustellenausweis - bei Wahl als Pflichtfeld kann kein BSA ohne Foto gedruckt werden'}"/>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-body-medium">
                {{"Besondere Qualifikationen" | translate : 'label-special-qualifications'}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Ersthelfer' | translate : 'label-first-aider'), options: staffData.firstAider, descriptionDefaultText: 'Wenn SICHTBAR oder PFLICHTF. wird Feld TELEFON- NUMMER autom. sichtbar. Wenn in den Grunddaten mit JA markiert, wird TELEFONNUMMER Pflichtfeld.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Betriebsantitäter' | translate : 'label-company-paramedic'), options: staffData.companyParamedic, descriptionDefaultText: 'Wenn SICHTBAR oder PFLICHTF. wird Feld TELEFON- NUMMER autom. sichtbar. Wenn in den Grunddaten mit JA markiert, wird TELEFONNUMMER Pflichtfeld.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Ersthelfer' | translate : 'label-supervisor'), options: staffData.supervisor, descriptionDefaultText: 'Wenn SICHTBAR oder PFLICHTF. wird Feld TELEFON- NUMMER autom. sichtbar. Wenn in den Grunddaten mit JA markiert, wird TELEFONNUMMER Pflichtfeld.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Telefon' | translate : 'label-phone'), options: staffData.phoneNumber, descriptionDefaultText: 'Wird automatisch SICHTBAR oder PFLICHTFELD, wenn ERSTHELFER, BETRIEBSSANITÄTER oder AUFSICHTSPERSON SICHTBAR oder PFLICHTFELD sind.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Email' | translate : 'label-email'), options: staffData.email, descriptionDefaultText: ''}"/>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-body-medium">
                {{"Erweiterte Daten: Ausweisdaten" | translate : 'label-extended-data-id-documents'}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Ausweisdokument' | translate : 'label-id-document'), options: staffData.idDocument, descriptionDefaultText: 'Empfohlen zur Verifikation des Baustellenausweises'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Ausweisdokument-Nr.' | translate : 'label-id-document-number'), options: staffData.idDocumentNumber, descriptionDefaultText: 'Empfohlen zur Verifizierung des Ausweisdokuments'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Ausgestellt am' | translate : 'label-issued-on'), options: staffData.idDocumentIssueDate, descriptionDefaultText: 'Empfohlen zur Verifizierung des Ausweisdokuments'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Gültig bis' | translate : 'label-valid-until'), options: staffData.idDocumentExpiryDate, descriptionDefaultText: 'Empfohlen in Verbindung mit AUSWEISDOKUMENT'}"/>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-body-medium">
                {{"Erweiterte Daten: Versicherungsdaten" | translate : 'label-extended-data-insurance'}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Krankenversicherung' | translate : 'label-health-insurance'), options: staffData.healthInsured, descriptionDefaultText: 'Wenn als Pflichtfeld markiert, muss in den Grunddaten die Auswahl JA/NEIN getroffen werden.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Krankenkasse oder A1 Dokument' | translate : 'label-health-insurance-company-or-a1'), options: staffData.healthInsuranceCompany, descriptionDefaultText: 'Auswahlmenü mit allen Krankenkassen. Wird automatisch ausgeblendet, wenn A1 DOKUMENT ausgewählt wird.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Kassenkartennummer' | translate : 'label-insurance-card-number'), options: staffData.healthInsuranceNr, descriptionDefaultText: 'Wird automatisch ausgeblendet, wenn bei KRANKENVERSICHERT? das Feld NEIN aktiviert wird. Steht in Abhängigkeit zu Krankenversicherung.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Gültig bis' | translate : 'label-valid-until'), options: staffData.healthInsuranceExpiryDate, descriptionDefaultText: 'Wird automatisch ausgeblendet, wenn bei KRANKENVERSICHERT? das Feld NEIN aktiviert wird. Steht in Abhängigkeit zu Krankenversicherung.'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Sozialversicherungsnummer' | translate : 'label-social-security-number'), options: staffData.socialSecurityNumber, descriptionDefaultText: 'Empfohlen bei Mitarbeitenden mit Baustellenzutritt'}"/>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-body-medium">
                {{"Erweiterte Daten: Aufenthalts- und Arbeitsgenehmigungsdaten" | translate : 'label-extended-data-residence-and-work-permit'}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Genehmigungsdokument' | translate : 'label-permit-document'), options: staffData.residencePermit, descriptionDefaultText: 'Wird Pflichtfeld, wenn NATIONALITÄT gewählt ist und Mitarbeitender nicht europäischer Staatsbürger ist oder dem EWR angehört'}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Gültig bis' | translate : 'label-valid-until'), options: staffData.residencePermitExpiryDate, descriptionDefaultText: ''}"/>

            <ng-container
              [ngTemplateOutlet]="accordionRow"
              [ngTemplateOutletContext]="{title: ('Europäischer Wirtschaftsraum' | translate : 'label-european-economic-area'), options: staffData.europeanEconomicArea, descriptionDefaultText: ''}"/>
          </mat-expansion-panel>
        </mat-accordion>
      </app-table-data-group>
    </app-table>
  }
  @else {
    <app-table-skeleton/>
  }
</app-overview>

<app-form-footer
  (save)="saveChanges()"
  (discard)="discardChanges()"/>

<ng-template #accordionRow let-title="title" let-options="options" let-descriptionDefaultText="descriptionDefaultText">
  <app-table-data-row>
    <app-table-data class="mat-body-medium" [width]="439">
      {{title}}
    </app-table-data>
    <app-table-data class="mat-body-medium" [width]="99">
      <button mat-icon-button (click)="setVisibility(options, !options.isVisible)" [disabled]="options.isRequired">
        @if(options.isVisible || options.isRequired){
          <ogs-m3-icon icon="eye"/>
        }
        @else {
          <ogs-m3-icon icon="eye-slash"/>
        }
      </button>
    </app-table-data>
    <app-table-data class="mat-body-medium" [width]="99">
      <mat-checkbox [checked]="options.isRequired" (change)="setRequirement(options, $event.checked)"/>
    </app-table-data>
    <app-table-data class="mat-body-medium" [width]="943">
      {{ descriptionDefaultText ? (descriptionDefaultText | translate : options.descriptionToken) : "" }}
    </app-table-data>
  </app-table-data-row>
</ng-template>
